import { Stack } from "@mui/system";
import { Typography } from "@mui/material";
import { ReactNode } from "react";

export const CardBlock = ({
  title,
  texts,
  btn,
  borderColor = "#FFD5A1",
  bgColor = "#FFF7E5",
}: {
  title: string;
  texts: string[];
  btn: ReactNode;
  borderColor?: string;
  bgColor?: string;
}) => {
  return (
    <Stack
      gap="24px"
      borderRadius="6px"
      bgcolor={bgColor}
      padding="16px"
      alignItems="flex-start"
      border={`1px solid ${borderColor}`}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        gap="24px"
      >
        <Stack gap="4px">
          <Typography
            variant="subtitle1"
            color="custom.textDarkBlue"
            sx={{ fontWeight: 500 }}
          >
            {title}
          </Typography>
          {texts.map((text) => (
            <Typography
              key={text}
              variant="body1"
              color="text.secondary"
              width={"700px"}
            >
              {text}
            </Typography>
          ))}
        </Stack>
      </Stack>
      {btn}
    </Stack>
  );
};
